<template>
    <div>
        <portal to="buttons">

        </portal>

        <div class="row">
            <b-col cols="12" lg="4">
                <b-card title="Etikette kø">
                    <div class="row mb-15">
                        <b-col>
                            {{queue.count}} etiketter i kø
                        </b-col>
                        <b-col cols="12" md="auto">
                            <b-button type="reset" variant="outline-info" @click="createList()" class="">
                                Opret etikette liste
                            </b-button>
                        </b-col>
                    </div>
                    <div class="row mb-5" v-for="item in queue.labels" :key="item.id">
                        <b-col>
                            {{item.name}}
                        </b-col>
                        <b-col cols="auto">
                            {{item.quantity}} stk.
                        </b-col>
                        <b-col cols="auto">
                            <b-button type="reset" variant="outline-danger" @click="deleteQueue(item)" size="sm" class="py-5 px-9">
                                Slet
                            </b-button>
                        </b-col>
                    </div>
                </b-card>
            </b-col>

            <b-col cols="12" lg="4">
                <b-card title="Lister">
                    <div class="row mb-5" v-for="item in lists" :key="item.id">
                        <b-col>
                            <a :href="item.link" target="_blank">
                                {{$moment(item.createDate).format("D. MMMM YYYY HH:mm")}}
                            </a>
                        </b-col>
                        <b-col cols="auto">
                            {{item.amount}} stk.
                        </b-col>
                        <b-col cols="auto">
                            <b-button type="reset" variant="outline-danger" @click="deletePrint(item)" size="sm" class="py-5 px-9">
                                Slet
                            </b-button>
                        </b-col>
                    </div>
                </b-card>
            </b-col>
        </div>



    </div>
</template>

<script>
    export default {
        components: {

        },
        data: () => ({
            queue: {
                count: 0,
                labels: []
            },
            lists: []
        }),
        computed: {},
        created() {
            this.getQueue()
            this.getLists()
        },
        mounted() { },
        methods: {
            getQueue() {
                this.$http.get("/api/labels").then(x => {
                    this.queue = x.data
                })
            },
            deleteQueue(item) {
                this.$http.post("/api/labels/delete/queue", item).then(x => {
                    this.getQueue()
                })
            },
            getLists() {
                this.$http.get("/api/labels/prints").then(x => {
                    this.lists = x.data
                })
            },
            createList() {
                this.$http.post("/api/labels/print").then(x => {
                    this.getQueue()
                    this.getLists()
                })
            },
            deletePrint(item) {
                this.$http.post("/api/labels/delete/print", item).then(x => {
                    this.getLists()
                })
            }
        },
    }
</script>